import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ResponseEnum } from "../../enums/ResponseEnum.enum";
import {
  IResponseLoginService
} from "../../interfaces/response-login-service";
import { IResponseService } from "../../interfaces/response-service";
import { AddressesUrlParams } from "../../parameters/addresses-url-params";
import { AuthenticationService } from "../../services/authentication.service";
import { SAlertComponent } from "../../shared/components/s-alert/s-alert.component";
import { UserModel } from "../../shared/models/user-model";
import { MesaggeText } from "../../shared/texts/mesagge-text";
import { MainStore } from "../../store/main-store";
import { Utils } from "../../utils/utils";
import { MENU_ITEM } from "../menu";
import { environment } from "../../../environments/environment";
import { AuthRefreshService } from "../../shared/services/auth-refresh.service";
import { StorageManager } from '../../services/storageManager';
import { setEncrypt } from '../../utils/Encrypt';
import { AsociadoModel } from "../../shared/models/datosAsociado";
import { FormService } from "../../services/form.service";
@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"]
})
export class LoginComponent implements OnInit {
  /**
   * Variables de la vista
   */
  login: UserModel;
  objAsociado: AsociadoModel;
  showFieldToken: boolean = false;
  constructor(
    public authService: AuthenticationService,
    private route: Router,
    public authRefresh: AuthRefreshService,
    public formServ: FormService
  ) {
    let self = this;

    window["OnExpired"] = function OnExpired() {
      self._OnExpired();
    };

    MainStore.db.RestData();
    MainStore.ORIGIN = 1;
    this.login = new UserModel();
    this.objAsociado = new AsociadoModel();
  }

  ngOnInit() {
    let parent = document.getElementById("g-recaptcha");
    parent.innerHTML = `<div
        class="g-recaptcha"
        data-sitekey="${environment.keycaptcha}"
        data-callback="OnExpired"
        ></div>`;
    $(parent).addClass(" recaptcha-login");
    
  }

  /**
   * @author Jose Wilson Mulato
   * @description Escucha el evento del click para validar los campos y enviar la autenticación
   */
  OnClickEntry() {
    /*this.objAsociado.nombre1 = 'adf';
    this.objAsociado.nombre2 = 'dasf';
    this.objAsociado.primerApellido = 'saf';
    this.objAsociado.segundoApellido = 'asdf';
    this.objAsociado.numeroDocumento = '12313';
    this.objAsociado.email = '12313';
    this.objAsociado.estado =1;
    MainStore.db.SetUser(this.objAsociado);
    this.LoadMenu(null);
    setTimeout(() => {
      return this.route.navigateByUrl(AddressesUrlParams.PathInicio());
    }, 1000);*/
    
    if (!this._OnExpired()) {
      return SAlertComponent.AlertWarning(MesaggeText.NOT_VALID_NOT_ROBOT);
    }
    
    const msg = this.ValidateFields();
    if (!msg) {
      this.sendToken();
    } else {
      SAlertComponent.AlertInfo(msg);
    }
  }


  reenviarCodigo() {        
    const msg = this.ValidateFields();
    if (!msg) {
      this.sendToken();
    } else {
      SAlertComponent.AlertInfo("Alert", msg);
    }
  }



  sendToken() {
    SAlertComponent.ShowSpinner();
    let data = {
      email: '',
      numeroCelular: '',
      tipoDocumento: this.login.tipDoc,
      documento: this.login.numDoc
    };
    this.authService.sendToken(data).
      then((response) => {
        SAlertComponent.CloseSpinner();
        if (response.status == 'FAILURE') {
          SAlertComponent.AlertError(response.message);
          return;
        } else if (response.status == 'OK') {

          SAlertComponent.AlertExit(response.data);
        }
        this.showFieldToken = true;
      }, (fail) => {
        SAlertComponent.AlertError('Error en el servicio ' + fail);
      })
  }



  validarToken() {
    const msg = this.ValidateFieldCodigo();
    if (!msg) {
      SAlertComponent.ShowSpinner();
      let data = {
        codigoSeguridad: this.login.token,
        tipoDocumento: this.login.tipDoc,
        documento: this.login.numDoc,
        cantidadIntentos: 0
      };
      this.authService.validToken(data).
        then((response) => {
          SAlertComponent.CloseSpinner();
          if (response.status == 'FAILURE') {
            SAlertComponent.AlertError(response.message);
            return;
          } else if (response.status == 'OK') {
            this.CheckResponse(response);
          }
        }, (fail) => {
          SAlertComponent.AlertError('Error en el servicio ' + fail);
        })
    } else {
      SAlertComponent.AlertError(msg);
    }
  }


  /**
   * @author Jose Wilson Mulato
   * @description Valida la respuesta que envia el servicio
   * @param response
   */
  CheckResponse(response: IResponseService): any {
    if (response.status == ResponseEnum.OK) {
      let infoAsociado = response.data;
      this.formServ.getCuentaMatricula(response.data.numDocumento).
      then((response) => {
        let matricula = response.data;

        if(matricula != undefined && matricula != null) {
          SAlertComponent.AlertInfo('Asociado(a): Su cuenta ya ha sido inscrita, en caso de requerir modificar sus datos o '
          + 'para mayor informaci\u00F3n por favor comunicarse con la línea 300 910 9898 opci\u00F3n 1-2-5.');
          return;
        }
        
        this.LoadData(infoAsociado);
        this.LoadMenu(infoAsociado);
        setTimeout(() => {
          SAlertComponent.CloseSpinner();
          return this.route.navigateByUrl(AddressesUrlParams.PathInicio());
        }, 1000);
        
      }, (fail) => {
        SAlertComponent.AlertError('Error en el servicio ' + fail);
      })


      
    } else if (response.status == ResponseEnum.FAILURE) {
      SAlertComponent.AlertError(
        MesaggeText.TITLE_ALERT,
        response.messageError
      );
      return;
    }
  }

  /**
   * @author Jose Wilson Mulato
   * @description Carga el menu en la aplicación
   * @param data
   */
  LoadMenu(data: IResponseLoginService) {
    let actions: Array<string> = [];
    MainStore.db.ClearMenu();
    let newList = this.FilterItemMenu(
      Utils.CopyJson(MENU_ITEM),
      actions
    );
    newList.forEach(x => MainStore.db.AddMenu(x));
  }

  /**
   * @author Jose Wilson Mulato
   * @description Filtra las opciones del menú
   * @param objs
   * @param actions
   */
  FilterItemMenu(objs: object, actions: string[]): any[] {
    let newList = [];
    for (const key in objs) {
      let pos: number = actions.findIndex(x => x == key);

      if (pos != -1) {
        let itemmenu = objs[key];
        let children = itemmenu.children;
        itemmenu.children = [];
        if (children) {
          actions.splice(pos, 1);
          itemmenu.children = this.FilterItemMenu(children, actions);
        }
        newList.push(itemmenu);
      }
    }
    return newList;
  }

  /**
   * @author Jose Wilson Mulato
   * @description Carga los datos basico del usuario que ingresa y el menu
   * @param data
   */
  LoadData(data: any): any {
    console.debug(data)
    this.objAsociado.nombre1 = data.nombre1;
    this.objAsociado.nombre2 = data.nombre2;
    this.objAsociado.primerApellido = data.primerApellido;
    this.objAsociado.segundoApellido = data.segundoApellido;
    this.objAsociado.numeroDocumento = data.numDocumento;
    this.objAsociado.estado = data.estado;
    this.objAsociado.email = data.email;
    MainStore.db.SetUser(this.objAsociado);
  }

  /**
   * @author Jose Wilson Mulato
   * @description Valida los campos que no este vacios
   * @param msg Mensaje del error que existe
   */
  private ValidateFields(): string {
    let msg: string = "";
    if (!this.login.tipDoc) {
      msg = MesaggeText.FIELD_EMPTY_TIP_DOC;
    } else if (!this.login.numDoc) {
      msg = MesaggeText.FIELD_EMPTY_DOC;
    }
    return msg;
  }


  ValidateFieldCodigo(): string {
    let msg: string = "";
    if (!this.login.token) {
      msg = MesaggeText.FIELD_EMPTY_TOKEN;
    }
    return msg;
  }


  /**
   * @author Jose Wilson Mulato
   * @description Habilitar o desahabilitar
   */
  _OnExpired() {
    var response = window["grecaptcha"].getResponse();
    if (response.length == 0) {
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/login/login.component.ts